import React, { useState, useEffect } from "react";
import {
	LinkedinLogo,
	EnvelopeSimple,
	UsersThree,
} from "@phosphor-icons/react";
import { motion, useAnimation } from "framer-motion";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TeamCard = ({
	image,
	firstname,
	lastname,
	designation,
	content,
	linkdIn,
	email,
	open,
	key,
	department,
}) => {
	const [isExpanded, setExpanded] = useState(false);
	const ToggleClass = (e) => {
		setExpanded(!isExpanded);
		e.stopPropagation();
	};

	//CARD BACKGROUND GRADIENT ANIMATIONS
	const [gradient, setGradient] = useState(
		"radial-gradient(circle at center, #000000, #292929)"
	);
	useEffect(() => {
		const handleMouseMove = (event) => {
			const x = event.clientX;
			const y = event.clientY;
			const gradientValue = `radial-gradient(circle at ${x}px ${y}px, #000000, #292929)`;
			setGradient(gradientValue);
		};
		const handleMouseLeave = () => {
			setGradient("radial-gradient(circle at center, #000000, #292929)");
		};
		window.addEventListener("mousemove", handleMouseMove);
		window.addEventListener("mouseleave", handleMouseLeave);
		return () => {
			window.removeEventListener("mousemove", handleMouseMove);
			window.removeEventListener("mouseleave", handleMouseLeave);
		};
	}, []);

	//CARD WOBBLE ANIMATIONS
	const variants = {
		hover: {
			scale: [1, 1.1, 1, 1.1, 1], // wobble effect
			rotateX: [0, 5, -5, 5, -5, 0], // 3D effect
			rotateY: [0, -5, 5, -5, 5, 0], // 3D effect
		},
	};

	return (
		<motion.div
			className={`${
				isExpanded ? "col-span-2 max-h-none" : "md:max-h-[300px]"
			} bg-card mt-20 rounded-xl px-6 shadow-2xl mb-10 md:mb-6 lg:mb-4 max-[767px]:mx-auto max-w-[300px] md:max-w-none w-full`}
			/* ---------------------------- WOBBLE ANIMATION ---------------------------- */
			variants={variants}
			transition={{ duration: 0.6 }}
			whileHover="hover"
			/* ---------------------- FOR CARD BACKGROUND ANIMATION --------------------- */
			style={{
				top: 0,
				left: 0,
				background: gradient,
				transition: "background 0.5s ease",
			}}
		>
			{/* ----------------------------- CARD CONTAINER ----------------------------- */}
			<div className="relative flex flex-col items-center ">
				{/* --------------------------------- Image -------------------------------- */}
				<img
					src={image}
					alt="Member Profile Photo"
					className="absolute -top-16 rounded-full object-cover w-24 h-24 shadow-2xl"
				/>

				{/* ---------------------------------- Name ---------------------------------- */}
				<h1 className="text-secondary text-[1.2rem] text-center pt-12 font-bold tracking-wide">
					{firstname}
					{lastname}
				</h1>

				{/* --------------------------------Job Position -------------------------------- */}
				<h3 className="text-white text-sm  font-bold text-center pt-2 tracking-wide">
					{designation}
				</h3>

				{/* --------------------------------- Summary -------------------------------- */}
				<p
					className={`${
						isExpanded ? "line-clamp-none" : "line-clamp-3"
					} text-slate-400 text-sm font-normal pt-4 text-center`}
				>
					{content}
				</p>
				<button
					className="text-gray-600 px-2 py-1 rounded-full hover:bg-gray-300 transition-colors duration-200 text-sm"
					onClick={ToggleClass}
				>
					{isExpanded ? "Read Less..." : "Read More..."}
				</button>
				<hr className="h-px w-[90%] border border-secondary bg-secondary my-6 " />

				{/* ------------------------------ CONTACT ICONS ----------------------------- */}
				<div className="flex items-center justify-evenly gap-x-10 pb-4">
					<a target="_blank" href={linkdIn}>
						<LinkedinLogo
							size={30}
							color="#4be4c0"
							className="hover:fill-[#fff] hover:scale-110  transition duration-300 ease-in-out"
						/>
					</a>
					<a
						href="#"
						onClick={(event) => {
							event.preventDefault();
							window.open(`mailto:${email}`, "_blank");
						}}
					>
						<EnvelopeSimple
							size={30}
							color="#4be4c0"
							className="hover:fill-[#fff] hover:scale-110 transition duration-300 ease-in-out"
						/>
					</a>
					{department && ( //if department is not null
						<button onClick={() => open(department)}>
							<UsersThree
								size={30}
								color="#4be4c0"
								className="hover:fill-[#fff] hover:scale-110  transition duration-300 ease-in-out"
							/>
						</button>
					)}
				</div>
			</div>
		</motion.div>
	);
};

export default TeamCard;
